<div class="page-padding" style="padding: 24px;">

  <div style="margin-left: 39%;" *ngIf="DigtalFormOverview == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>
  <div class="panel" *ngIf="DigtalFormOverview != null">
    <div class="panel__header">
      <span class="panel__header__title">
        {{form.FormName}} - {{form.TemplateName}}
      </span>
    </div>

    <div class="panel__content flex flex--align-center" style="justify-content: initial;" *ngIf="headerFormList!=null">

      <div class="column-container flex-grow" style="width: 50%;">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{headerFormList[0].fieldname}}
            </span>
            <span *ngIf="headerFormList[0].fieldname=='UnitNo'" class="text-block__important" style="cursor: pointer;">
              <a (click)="OpenEqDetails()">{{headerFormList[0].answer}}</a>
            </span>
            <span *ngIf="headerFormList[0].fieldname!='UnitNo'" class="text-block__important">
              {{headerFormList[0].answer}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{headerFormList[1].fieldname}}
            </span>
            <span *ngIf="headerFormList[1].fieldname=='UnitNo'" class="text-block__important" style="cursor: pointer;">
              <a (click)="OpenEqDetails()">{{headerFormList[1].answer}}</a>
            </span>
            <span *ngIf="headerFormList[1].fieldname!='UnitNo'" class="text-block__important">
              {{headerFormList[1].answer}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{headerFormList[2].fieldname}}
            </span>
            <span *ngIf="headerFormList[2].fieldname=='UnitNo'" class="text-block__important" style="cursor: pointer;">
              <a (click)="OpenEqDetails()">{{headerFormList[2].answer}}</a>
            </span>
            <span *ngIf="headerFormList[2].fieldname!='UnitNo'" class="text-block__important">
              {{headerFormList[2].answer}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{headerFormList[3].fieldname}}
            </span>
            <span *ngIf="headerFormList[3].fieldname=='UnitNo'" class="text-block__important" style="cursor: pointer;">
              <a (click)="OpenEqDetails()">{{headerFormList[3].answer}}</a>
            </span>
            <span *ngIf="headerFormList[3].fieldname!='UnitNo'" class="text-block__important">
              {{headerFormList[3].answer}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              {{headerFormList[4].fieldname}}
            </span>
            <span *ngIf="headerFormList[4].fieldname=='UnitNo'" class="text-block__important" style="cursor: pointer;">
              <a (click)="OpenEqDetails()">{{headerFormList[4].answer}}</a>
            </span>
            <span *ngIf="headerFormList[4].fieldname!='UnitNo'" class="text-block__important">
              {{headerFormList[4].answer}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              {{headerFormList[5].fieldname}}
            </span>
            <span *ngIf="headerFormList[5].fieldname=='UnitNo'" class="text-block__important" style="cursor: pointer;">
              <a (click)="OpenEqDetails()">{{headerFormList[5].answer}}</a>
            </span>
            <span *ngIf="headerFormList[5].fieldname!='UnitNo'" class="text-block__important">
              {{headerFormList[5].answer}}
            </span>
          </div>
        </div>
        <div class="column-container__column" *ngIf="workOrder != null && showWorkOrder">
          <div class="text-block">
            <span class="text-block__label">
             Work Order
            </span>
            <span class="text-block__important">
              <input matInput placeholder="Work Order"
                     style=" min-width: 200px!important;height: 40px!important;display: inline !important; background-color: #F4F7FA !important;
                      color: #1D2F36 !important; min-height: 40px!important; padding: 10px!important; min-width: 200px!important; border: groove; border-color: black; border-width:thin ;"
                     class="get-Input" type="text" [(ngModel)]="workOrder" (change)="UpdateWorkOrder($event)">
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block" *ngIf="showSMU">
            <span class="text-block__label">
              SMU
            </span>
            <span class="text-block__important">
              <input matInput placeholder="SMU"
                     style=" min-width: 200px!important;height: 40px!important;display: inline !important; background-color: #F4F7FA !important;
                      color: #1D2F36 !important; min-height: 40px!important; padding: 10px!important; min-width: 200px!important; border: groove; border-color: black; border-width:thin ;"
                     class="get-Input" type="number" [(ngModel)]="InspectionSMU" (change)="UpdateInspectionSMU($event)">
            </span>
          </div>
          <!-- new code  -->
          <div class="text-block" style="margin-bottom: 10px;" *ngIf="showDate"> 
            <span class="text-block__label" style="margin-bottom: 0px;">
              Start Date
            </span>
            <span class="text-block__important">
              <mat-form-field class="header-form-full-width">
                <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate"
                       (dateChange)="UpdateInspectionDate($event)">
                <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                <mat-datepicker #pickerStart></mat-datepicker>
              </mat-form-field>
            </span>
          </div>
          <!-- end code -->
        </div>

      </div>

    </div>
  </div>
  <div style="display: flex; flex-direction:column; justify-content: space-between;" *ngIf="DigtalFormOverview != null">
    <div class="input-container addsapce" *ngIf="DigtalFormOverview != null" style="display: flex; flex-direction: row; justify-content: space-between;">
      <div class="text-block">
        <span class="text-block__label">
          Form Status
        </span>
        <span class="text-block__important">
          <select id="satus" placeholder="Select Status" [(ngModel)]="form.FormStatusID" class="get-Input"
                  (change)="UpdateStatus(form.QuestionsOverAllStatus)" ngDefaultControl>
            <option [value]="status.ID" *ngFor="let status of statusTypes">
              {{status.Status}}
            </option>
          </select>
        </span>
      </div>
      <div class="text-block">
        <span class="text-block__label">
          Summary Start Date
        </span>
        <span class="text-block__important">
          <mat-form-field class="header-form-full-width">
            <input matInput [matDatepicker]="pickerSummStart" [(ngModel)]="summStartDate">
            <mat-datepicker-toggle matSuffix [for]="pickerSummStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerSummStart></mat-datepicker>
          </mat-form-field>
        </span>
      </div>
      <div class="text-block">
        <div style="display: flex; flex-direction: row;">
          <div>
            <span class="text-block__label">
              Summary End Date
            </span>
            <span class="text-block__important">
              <mat-form-field class="header-form-full-width">
                <input matInput [matDatepicker]="pickerSummEnd" [(ngModel)]="summEndDate">
                <mat-datepicker-toggle matSuffix [for]="pickerSummEnd"></mat-datepicker-toggle>
                <mat-datepicker #pickerSummEnd></mat-datepicker>
              </mat-form-field>
            </span>
          </div>
          <div>
            <button type="button" mat-raised-button color="warn" style="margin: 20px;" [disabled]="savingForm" [class.loading]="savingForm" (click)="LoadFormUploadDetails()">Search Inspections</button>
          </div>
        </div>
        
      </div>
      <div class="text-block"></div>
      <div class="text-block"></div>
      <div class="text-block"></div>
      <div class="text-block" style="padding-top: 20px;">
        <a class="button button--primary" style="margin-left: 10px;" (click)="RefreshInspection()">
          <span class="button__text">Refresh Inspection</span>
        </a>
        <a class="button button--primary" style="margin-left: 10px;" (click)="AddToReportOptions()">
          <span class="button__text"> Report Option</span>
        </a>
        <a class="button button--primary" style="margin-left: 10px;" (click)="GetPdfDigitalForm()">
          <span class="button__text"> Generate PDF</span>
        </a>
      </div>
      <div class="text-block">
        <i *ngIf="form.Notes!=''" class="material-icons button__icon" style="font-size: 28px; vertical-align: middle; font-size: 28px; color: royalblue; vertical-align: middle; cursor: pointer;"
           title="General Note"
           (click)="OpenOveralNotes()">insert_comment</i>
        <i *ngIf="form.Notes==''" class="material-icons button__icon" style="font-size: 28px; vertical-align: middle; font-size: 28px; vertical-align: middle; cursor: pointer;"
           title="General Note"
           (click)="OpenOveralNotes()">insert_comment</i>

      </div>
    </div>


      <div style="margin-bottom: 2%;">
        <ng-container *ngFor="let fc of formQCategories">
          <mat-expansion-panel class="parametersPanel" [expanded]="true">
            <mat-expansion-panel-header style="background: #E0E0E0;" class="mat-expansion-panel-header-custom">
              <div class="panel__header">
                <span class="panel__header__title" style="font-size: larger;">
                  <b>{{fc.QCategoryName}}</b>
                </span>
              </div>
            </mat-expansion-panel-header>

            <div class="of">
              <!-- <ng-container *ngFor="let fq of formQuestions let i=index"> -->
              <ng-container *ngFor="let fq of fc.AllQuestions; let i = index">
                <div class="row flex" [ngClass]="fq.IsCat == 0 ? 'cat-row' : i%2 == 0 ? 'alt-row' : ''">
                  <div class="th item" *ngIf="fq.IsCat == 0" [ngClass]="fq.IsCat == 0 ? 'cat-row' : i%2 == 0 ? 'alt-row' : ''">
                    <div class="flex">
                      <div class="q-item-cat">
                        <span class="panel__header__title" style="font-size: medium; font-style: italic;">
                          <b>{{fq.QuestionCat}}</b>
                        </span>
                      </div>
                      <div *ngIf="fq.IsCat == 0" class="flexrow">
                        <div class="q-item-label">
                          <div class="right-text">
                            <span class="panel__header__title">
                              Date:
                            </span>
                          </div>
                          <div class="right-text">
                            <span class="panel__header__title">
                              SMU:
                            </span>
                          </div>
                          <div class="right-text">
                            <span class="panel__header__title">
                              Status:
                            </span>
                          </div>
                        </div>
                        <div class="item item-top">
                          <div>
                            {{fq.InspectionDate}}
                          </div>
                          <div>
                            {{fq.SMU}}
                          </div>
                          <div>
                            {{fq.InspectionStatus}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="th item" *ngIf="fq.IsCat > 0" [ngClass]="i%2 == 0 ? 'alt-row' : ''">
                    <div class="flex item-center">
                      <div class="q-item flexcolumn item-link" title="Click to open question for inspection." (click)="LoadSelectedCatData(fq.QuestionCatId, fq.QuestionId, fq.UploadId)">
                        <span class="panel__header__title">
                          {{fq.QTitle}}
                        </span>
                        <span style="font-size: small;">
                          <b>Inspected By:</b> {{fq.InspectorName | aesDecrypt }}
                          {{fq.InspectorName!=null?" - ":""}}
                          {{fq.InspectorName!=null?fq.AnswerDate:""}}
                        </span>
                      </div>
                      <div class="q-item-label item-link" title="Click to open question for inspection." (click)="LoadSelectedCatData(fq.QuestionCatId, fq.QuestionId, fq.UploadId)"></div>
                      <div class="item">
                        <table cellpadding="0" cellspacing="0">
                          <tr>
                            <td *ngIf="fq.QuestionTypeId !== 3" style="width:100px;" class="item-link" title="Click to open question for inspection." (click)="LoadSelectedCatData(fq.QuestionCatId, fq.QuestionId, fq.UploadId)">
                              {{fq.Answer}}
                            </td>
                            <td *ngIf="fq.QuestionTypeId === 3" style="width:100px;" class="item-link" (click)="LoadSelectedCatData(fq.QuestionCatId, fq.QuestionId, fq.UploadId)">
                              <ng-container *ngFor="let ans of fq.AnswerArray; let last = last">
                                <span [matTooltip]="ans.hasTooltip ? ans.full : null" matTooltipPosition="above">
                                  {{ ans.display }}
                                </span>
                                <span *ngIf="!last">, </span>
                              </ng-container>
                            </td>
                            <td style="width:30px;">
                              <i *ngIf="fq.ImagesCount == 0" class="material-icons button__icon"
                                 style="font-size: 24px; margin-right: 5px; color: lightgray; vertical-align: middle;">camera_alt</i>
                              <i *ngIf="fq.ImagesCount > 0" class="material-icons button__icon"
                                 style="font-size: 24px; margin-right: 5px;color: green;vertical-align: middle;">camera_alt</i>
                            </td>
                            <td style="width:30px;">
                              <i *ngIf="fq.CommentsCount == 0" class="material-icons button__icon"
                                 style="font-size: 24px; vertical-align: middle; color: lightgray; margin-right: 5px;">assignment</i>
                              <i *ngIf="fq.CommentsCount > 0" class="material-icons button__icon"
                                 style="font-size: 24px; vertical-align: middle; color: green; margin-right: 5px;">assignment</i>
                            </td>
                            <td style="width:30px;">
                              <a *ngIf="fq.QuestionTypeId!=6" (click)="OpenQuestionHistory(fq.QuestionId, fq.UploadId)">
                                <i class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; margin-right: 5px; cursor: pointer;">history</i>
                              </a>
                              <a *ngIf="fq.QuestionTypeId==6" (click)="OpenQuestionHistoryStructural(fq.QuestionId, fq.UploadId)">
                                <i class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; margin-right: 5px; cursor: pointer;">history</i>
                              </a>
                            </td>
                            <td style="width:30px;">
                              <a [matMenuTriggerFor]="flagtypes" *ngIf="fq.QuestionTypeId==6">
                                <i *ngIf="fq.QuestionFlag > 0" class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; cursor: pointer;" title="{{GetFlagTitle(fq)}}"
                                   [style.color]="GetColor(fq)">flag</i>

                              </a>
                              <a [matMenuTriggerFor]="flagtypes" *ngIf="fq.QuestionTypeId!=6">
                                <i *ngIf="fq.QuestionFlag > 0" class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; cursor: pointer;" title="{{GetFlagTitle(fq)}}"
                                   [style.color]="GetColor(fq)">flag</i>

                                <mat-menu #flagtypes="matMenu">
                                  <span mat-menu-item style="font-weight: bold;" *ngIf="fq.QuestionTypeId!=6">
                                    Select
                                    Flag
                                    Type
                                  </span>
                                  <ng-container *ngFor="let type of flagTypes">
                                    <div style="display: flex;flex-direction: row-reverse;" *ngIf="fq.QuestionTypeId!=6">
                                      <i class="material-icons button__icon"
                                         style="font-size: 24px; vertical-align: middle; cursor: pointer; margin-top: 5%"
                                         [style.color]="type.Color">flag</i>
                                      <button mat-menu-item (click)="UpdateFlag(type,fq)">{{type.Name}}</button>
                                    </div>
                                  </ng-container>

                                  <button *ngIf="isSupervisour==true && fq.QuestionFlag>0 && fq.QuestionTypeId!=6"
                                          mat-menu-item (click)="CompleteFlag(fq)">
                                    Clear Flag
                                  </button>
                                </mat-menu>
                              </a>
                              <i *ngIf="fq.QuestionFlag == 0" class="material-icons button__icon"
                                 style="font-size: 24px; vertical-align: middle;"></i>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="fq.IsCat == 0">
                    <ng-container *ngFor="let foq of formOtherQuestions let j=index">
                      <div class="td item" *ngIf="foq.IsCat == 0 && fq.QuestionCatId == foq.QuestionCatId && fq.QuestionId == foq.QuestionId">
                        <table cellpadding="0" cellspacing="0">
                          <tr>
                            <td>
                              {{foq.InspectionDate}}
                            </td>
                          <tr>
                            <td>
                              {{foq.SMU}}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              {{foq.InspectionStatus}}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="fq.IsCat > 0">
                    <ng-container *ngFor="let foq of formOtherQuestions let j=index">
                      <div class="td item" *ngIf="foq.IsCat > 0 && fq.QuestionCatId == foq.QuestionCatId && fq.QuestionId == foq.QuestionId">
                        <table cellpadding="0" cellspacing="0">
                          <tr>
                            <td *ngIf="foq.QuestionTypeId !== 3" style="width:100px;" class="item-link" title="Click to open question for inspection." (click)="LoadSelectedCatData(foq.QuestionCatId, foq.QuestionId, foq.UploadId)">
                              {{foq.Answer}}
                            </td>
                            <td *ngIf="foq.QuestionTypeId === 3" style="width:100px;" class="item-link" (click)="LoadSelectedCatData(foq.QuestionCatId, foq.QuestionId, foq.UploadId)">
                              <ng-container *ngFor="let ans of foq.AnswerArray; let last = last">
                                <span [matTooltip]="ans.hasTooltip ? ans.full : null" matTooltipPosition="above">
                                  {{ ans.display }}
                                </span>
                                <span *ngIf="!last">, </span>
                              </ng-container>
                            </td>
                            <td>
                              <i *ngIf="foq.ImagesCount == 0" class="material-icons button__icon"
                                 style="font-size: 24px; margin-right: 5px; color: lightgray; vertical-align: middle;">camera_alt</i>
                              <i *ngIf="foq.ImagesCount > 0" class="material-icons button__icon"
                                 style="font-size: 24px; margin-right: 5px; color: green;vertical-align: middle;">camera_alt</i>
                            </td>
                            <td>
                              <i *ngIf="foq.CommentsCount == 0" class="material-icons button__icon"
                                 style="font-size: 24px; vertical-align: middle; color: lightgray; margin-right: 5px;">assignment</i>
                              <i *ngIf="foq.CommentsCount > 0" class="material-icons button__icon"
                                 style="font-size: 24px; vertical-align: middle; color: green; margin-right: 5px;">assignment</i>
                            </td>
                            <td>
                              <a *ngIf="foq.QuestionTypeId!=6" (click)="OpenQuestionHistory(foq.QuestionId, foq.UploadId)">
                                <i class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; margin-right: 5px; cursor: pointer;">history</i>
                              </a>
                              <a *ngIf="foq.QuestionTypeId==6" (click)="OpenQuestionHistoryStructural(foq.QuestionId, foq.UploadId)">
                                <i class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; margin-right: 5px; cursor: pointer;">history</i>
                              </a>
                            </td>
                            <td>
                              <a [matMenuTriggerFor]="flagtypes" *ngIf="foq.QuestionTypeId==6">
                                <i *ngIf="foq.QuestionFlag > 0" class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; cursor: pointer;" title="{{GetFlagTitle(foq)}}"
                                   [style.color]="GetColor(foq)">flag</i>

                              </a>
                              <a [matMenuTriggerFor]="flagtypes" *ngIf="foq.QuestionTypeId!=6">
                                <i *ngIf="foq.QuestionFlag > 0" class="material-icons button__icon"
                                   style="font-size: 24px; vertical-align: middle; cursor: pointer;" title="{{GetFlagTitle(foq)}}"
                                   [style.color]="GetColor(foq)">flag</i>

                                <mat-menu #flagtypes="matMenu">
                                  <span mat-menu-item style="font-weight: bold;" *ngIf="foq.QuestionTypeId!=6">
                                    Select
                                    Flag
                                    Type
                                  </span>
                                  <ng-container *ngFor="let type of flagTypes">
                                    <div style="display: flex;flex-direction: row-reverse;" *ngIf="foq.QuestionTypeId!=6">
                                      <i class="material-icons button__icon"
                                         style="font-size: 24px; vertical-align: middle; cursor: pointer; margin-top: 5%"
                                         [style.color]="type.Color">flag</i>
                                      <button mat-menu-item (click)="UpdateFlag(type,foq)">{{type.Name}}</button>
                                    </div>
                                  </ng-container>

                                  <button *ngIf="isSupervisour==true && foq.QuestionFlag>0 && foq.QuestionTypeId!=6"
                                          mat-menu-item (click)="CompleteFlag(foq)">
                                    Clear Flag
                                  </button>
                                </mat-menu>
                              </a>
                              <i *ngIf="foq.QuestionFlag == 0" class="material-icons button__icon"
                                 style="font-size: 24px; vertical-align: middle;"></i>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </mat-expansion-panel>
        </ng-container>
      </div>
    </div>
</div>
